import { Injectable } from '@angular/core';
import { ReceiptApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { ReceiptAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class ReceiptEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(ReceiptAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => ReceiptAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: ReceiptApiService, private _actions$: Actions, private _store: Store) {}
}
